import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from './component/Navbar';
import Footer from './component/Footer';
import ConsultationModal from './component/ConsultationModal';

const springMenu = [
  {
    image: 'https://images.unsplash.com/photo-1540420773420-3366772f4999?auto=format&fit=crop&w=300&q=80',
    name: 'Peas with Mint and Rose Petals',
  },
  {
    image: 'https://images.unsplash.com/photo-1551782450-a2132b4ba21d?auto=format&fit=crop&w=300&q=80',
    name: 'Grilled Corn with Herb Butter',
  },
  {
    image: 'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?auto=format&fit=crop&w=300&q=80',
    name: 'Falafel-Spiced Tomatoes on Whole Wheat Flatbread',
  },
  {
    image: 'https://images.unsplash.com/photo-1633964913295-ceb43826e7c9?auto=format&fit=crop&w=300&q=80',
    name: 'Primavera Risotto',
  },
  {
    image: 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?auto=format&fit=crop&w=300&q=80',
    name: "Farmer's Market Quinoa Salad",
  },
  {
    image: 'https://images.unsplash.com/photo-1510812431401-41d2bd2722f3?auto=format&fit=crop&w=300&q=80',
    name: 'Sparkling Wine with Ginger Ale and Cherries',
  },
];

const stats = [
  { value: '10M+', label: 'Active Bidders' },
  { value: '500+', label: 'Eminent Chefs' },
  { value: '50+', label: 'Cities Live' },
  { value: '₹1Cr+', label: 'Meals Auctioned' },
];

const HungryTopProductPage = () => {
  const [isConsultationOpen, setIsConsultationOpen] = useState(false);
  const [bidActive, setBidActive] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div style={{ backgroundColor: '#04050E', color: '#FFFFFF', minHeight: '100vh', position: 'relative' }}>

      {/* ── Shared Site Navbar ── */}
      <Navbar onOpenConsultation={() => setIsConsultationOpen(true)} />

      {/* ── HERO: Full-Screen Video ── */}
      <div
        style={{
          position: 'relative',
          height: '100vh',
          minHeight: '600px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
        }}
      >
        {/* Background Video */}
        <video
          autoPlay
          muted
          loop
          playsInline
          style={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            zIndex: 0,
          }}
        >
          <source src="/assets/video/food1.mp4" type="video/mp4" />
          <source src="/assets/video/food2.webm" type="video/webm" />
        </video>

        {/* Dark Gradient Overlay */}
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background:
              'linear-gradient(180deg, rgba(4,5,14,0.6) 0%, rgba(4,5,14,0.3) 40%, rgba(4,5,14,0.88) 100%)',
            zIndex: 1,
          }}
        />

        {/* Hero Content */}
        <div
          style={{
            position: 'relative',
            zIndex: 2,
            textAlign: 'center',
            padding: '0 24px',
            maxWidth: '900px',
            width: '100%',
          }}
        >
          {/* Italian Welcome Badge */}
          <div
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '10px',
              background: 'rgba(255, 165, 0, 0.12)',
              border: '1px solid rgba(255, 165, 0, 0.45)',
              padding: '8px 22px',
              borderRadius: '9999px',
              marginBottom: '28px',
              backdropFilter: 'blur(12px)',
            }}
          >
            <span style={{ fontSize: '1.2rem' }}>🍽️</span>
            <span
              style={{
                color: '#FFA500',
                fontWeight: 800,
                fontSize: '0.88rem',
                letterSpacing: '0.22em',
                textTransform: 'uppercase',
              }}
            >
              Benvenuto!
            </span>
          </div>

          {/* Main Headline */}
          <h1
            style={{
              fontSize: 'clamp(2.8rem, 7vw, 5.5rem)',
              fontWeight: 900,
              color: '#FFFFFF',
              lineHeight: 1.05,
              marginBottom: '16px',
              letterSpacing: '-0.03em',
              textShadow: '0 4px 30px rgba(0,0,0,0.7)',
            }}
          >
            GOURMET MEAL<br />
            <span
              style={{
                background:
                  'linear-gradient(135deg, #FF6B35 0%, #FFA500 50%, #FFD700 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              AT YOUR DINNER TABLE
            </span>
          </h1>

          <p
            style={{
              fontSize: 'clamp(1rem, 2.2vw, 1.4rem)',
              color: 'rgba(255,255,255,0.88)',
              marginBottom: '10px',
              fontWeight: 600,
              textShadow: '0 2px 10px rgba(0,0,0,0.5)',
            }}
          >
            World's First Food Auction Platform
          </p>
          <p
            style={{
              fontSize: 'clamp(0.85rem, 1.5vw, 1.05rem)',
              color: 'rgba(255,200,100,0.9)',
              marginBottom: '40px',
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: '0.25em',
            }}
          >
            India's Most Acclaimed Restaurants
          </p>

          {/* CTAs */}
          <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <a
              href="https://play.google.com/store/apps/details?id=com.hungrytop"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                padding: '16px 36px',
                borderRadius: '9999px',
                background: 'linear-gradient(135deg, #FF6B35 0%, #FFA500 100%)',
                color: '#FFFFFF',
                fontWeight: 800,
                fontSize: '1.05rem',
                textDecoration: 'none',
                boxShadow: '0 8px 30px rgba(255,107,53,0.6)',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '10px',
              }}
            >
              <span>Would you like to Bid?</span>
              <i className="fas fa-gavel" style={{ fontSize: '1rem' }}></i>
            </a>
            <a
              href="#about-section"
              style={{
                padding: '16px 36px',
                borderRadius: '9999px',
                background: 'rgba(255,255,255,0.1)',
                backdropFilter: 'blur(12px)',
                border: '1px solid rgba(255,255,255,0.25)',
                color: '#FFFFFF',
                fontWeight: 700,
                fontSize: '1.05rem',
                textDecoration: 'none',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '10px',
              }}
            >
              <span>Discover More</span>
              <i className="fas fa-arrow-down" style={{ fontSize: '0.9rem' }}></i>
            </a>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div
          style={{
            position: 'absolute',
            bottom: '36px',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 2,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              width: '28px',
              height: '46px',
              borderRadius: '14px',
              border: '2px solid rgba(255,255,255,0.35)',
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'center',
              padding: '6px 0',
            }}
          >
            <div
              style={{
                width: '4px',
                height: '12px',
                borderRadius: '2px',
                background: '#FFA500',
                animation: 'scrollBounce 1.6s ease-in-out infinite',
              }}
            />
          </div>
        </div>
      </div>

      {/* ── ABOUT SECTION ── */}
      <div
        id="about-section"
        style={{
          padding: '56px 0',
          background: 'linear-gradient(180deg, #04050E 0%, #0A0D1E 100%)',
        }}
      >
        <div className="ht-container">
          {/* Stats Bar — Compact */}
          <div
            className="hungrytop-stats-grid"
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(4, 1fr)',
              gap: '0',
              marginBottom: '40px',
              borderRadius: '16px',
              background: 'rgba(255,165,0,0.05)',
              border: '1px solid rgba(255,165,0,0.15)',
              overflow: 'hidden',
            }}
          >
            {stats.map((s, i) => (
              <div
                key={i}
                style={{
                  textAlign: 'center',
                  padding: '20px 16px',
                  borderRight: i < stats.length - 1 ? '1px solid rgba(255,165,0,0.1)' : 'none',
                }}
              >
                <div
                  style={{
                    fontSize: 'clamp(1.6rem, 2.8vw, 2.2rem)',
                    fontWeight: 900,
                    background: 'linear-gradient(135deg, #FF6B35, #FFA500)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',
                    lineHeight: 1.1,
                    marginBottom: '4px',
                  }}
                >
                  {s.value}
                </div>
                <div style={{ color: '#94A3B8', fontSize: '0.8rem', fontWeight: 600 }}>
                  {s.label}
                </div>
              </div>
            ))}
          </div>

          {/* About Grid — 55/45 split */}
          <div
            className="hungrytop-about-grid"
            style={{
              display: 'grid',
              gridTemplateColumns: '55% 1fr',
              gap: '36px',
              alignItems: 'center',
            }}
          >
            {/* Left: Text */}
            <div>
              <div
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  background: 'rgba(255,165,0,0.1)',
                  border: '1px solid rgba(255,165,0,0.3)',
                  padding: '4px 12px',
                  borderRadius: '9999px',
                  marginBottom: '14px',
                }}
              >
                <span style={{ color: '#FFA500', fontSize: '0.72rem', fontWeight: 800, letterSpacing: '0.18em', textTransform: 'uppercase' }}>
                  Food Auction
                </span>
              </div>

              <h2
                style={{
                  fontSize: 'clamp(1.6rem, 2.8vw, 2.2rem)',
                  fontWeight: 900,
                  color: '#FFFFFF',
                  marginBottom: '14px',
                  lineHeight: 1.2,
                  letterSpacing: '-0.02em',
                }}
              >
                Challenging Every{' '}
                <span
                  style={{
                    background: 'linear-gradient(135deg, #FF6B35, #FFA500)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',
                  }}
                >
                  Food Industry Norm
                </span>
              </h2>

              <p style={{ color: '#CBD5E1', fontSize: '0.95rem', lineHeight: 1.65, marginBottom: '10px' }}>
                We believe in challenging the set food and beverage industry norms and status quo, reforming and reshaping market dynamics.
              </p>
              <p style={{ color: '#94A3B8', fontSize: '0.9rem', lineHeight: 1.6, marginBottom: '10px' }}>
                We make your food craving a reality at your price through Auction — uniquely designed, simple to use, and user friendly.
              </p>
              <p style={{ color: '#94A3B8', fontSize: '0.9rem', lineHeight: 1.6, marginBottom: '22px' }}>
                HungryTop is a well-diversified Food &amp; Beverage Auction Platform offering food products from eminent chefs across the Globe.
              </p>

              <a
                href="https://play.google.com/store/apps/details?id=com.hungrytop"
                target="_blank"
                rel="noopener noreferrer"
                onMouseEnter={() => setBidActive(true)}
                onMouseLeave={() => setBidActive(false)}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '10px',
                  padding: '11px 24px',
                  borderRadius: '9999px',
                  background: bidActive
                    ? 'linear-gradient(135deg, #FF6B35 0%, #FFA500 100%)'
                    : 'rgba(255,107,53,0.12)',
                  border: '1px solid rgba(255,107,53,0.5)',
                  color: bidActive ? '#fff' : '#FFA500',
                  fontWeight: 800,
                  fontSize: '0.9rem',
                  textDecoration: 'none',
                  transition: 'all 0.3s ease',
                  boxShadow: bidActive ? '0 6px 24px rgba(255,107,53,0.5)' : 'none',
                }}
              >
                <i className="fas fa-gavel"></i>
                <span>Would you like to Bid?</span>
              </a>
            </div>

            {/* Right: Video Card */}
            <div
              style={{
                borderRadius: '20px',
                overflow: 'hidden',
                border: '1px solid rgba(255,165,0,0.2)',
                boxShadow: '0 20px 60px rgba(0,0,0,0.6), 0 0 30px rgba(255,165,0,0.12)',
                position: 'relative',
              }}
            >
              <video autoPlay muted loop playsInline style={{ width: '100%', display: 'block', maxHeight: '380px', objectFit: 'cover' }}>
                <source src="/assets/video/food2.mp4" type="video/mp4" />
                <source src="/assets/video/food2.webm" type="video/webm" />
              </video>
              <div
                style={{
                  position: 'absolute',
                  inset: 0,
                  background: 'linear-gradient(180deg, transparent 55%, rgba(4,5,14,0.88) 100%)',
                }}
              />
              {/* Review Badge */}
              <div
                style={{
                  position: 'absolute',
                  bottom: '14px',
                  left: '14px',
                  right: '14px',
                  background: 'rgba(4,5,14,0.92)',
                  backdropFilter: 'blur(16px)',
                  border: '1px solid rgba(255,165,0,0.2)',
                  borderRadius: '12px',
                  padding: '10px 14px',
                }}
              >
                <div style={{ display: 'flex', gap: '3px', marginBottom: '4px' }}>
                  {[1,2,3,4,5].map(s => (
                    <span key={s} style={{ color: '#FFA500', fontSize: '0.8rem' }}>★</span>
                  ))}
                </div>
                <p style={{ color: '#E2E8F0', fontSize: '0.82rem', fontWeight: 600, lineHeight: 1.35, marginBottom: '4px' }}>
                  "Absolutely loved it. Amazing food and charismatic chefs."
                </p>
                <span style={{ color: '#FFA500', fontSize: '0.75rem', fontWeight: 700 }}>Verified Bidder</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── SPRING MENU SECTION ── */}
      <div
        style={{
          padding: '64px 0',
          background: 'linear-gradient(180deg, #0A0D1E 0%, #060816 100%)',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        {/* Ambient glow */}
        <div
          style={{
            position: 'absolute',
            top: '-100px',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '800px',
            height: '800px',
            borderRadius: '50%',
            background: 'rgba(255,165,0,0.04)',
            filter: 'blur(80px)',
            pointerEvents: 'none',
          }}
        />

        <div className="ht-container" style={{ position: 'relative', zIndex: 2 }}>
          {/* Header — Compact single line */}
          <div style={{ textAlign: 'center', marginBottom: '20px' }}>
            <div
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                background: 'rgba(255,165,0,0.08)',
                border: '1px solid rgba(255,165,0,0.2)',
                padding: '4px 14px',
                borderRadius: '9999px',
                marginBottom: '10px',
              }}
            >
              <span style={{ color: '#FFA500', fontSize: '0.72rem', fontWeight: 800, letterSpacing: '0.2em', textTransform: 'uppercase' }}>
                Farm to Table
              </span>
            </div>
            <h2
              style={{
                fontSize: 'clamp(1.5rem, 2.8vw, 2.2rem)',
                fontWeight: 900,
                marginBottom: '8px',
                letterSpacing: '-0.02em',
                lineHeight: 1.2,
              }}
            >
              <span style={{ color: '#FFFFFF' }}>A Sneak Peak of the </span>
              <span
                style={{
                  background: 'linear-gradient(135deg, #FF6B35, #FFA500, #FFD700)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                }}
              >
                New Spring Menu 🌿
              </span>
            </h2>
            <p style={{ color: '#64748B', fontSize: '0.9rem', maxWidth: '500px', margin: '0 auto', lineHeight: 1.5 }}>
              Bid on exclusive dishes by world-class chefs. Fresh. Local. Extraordinary.
            </p>
          </div>

          {/* Menu Grid — Compact */}
          <div
            className="spring-menu-grid"
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '10px',
              marginBottom: '24px',
            }}
          >
            {springMenu.map((dish, i) => (
              <div
                key={i}
                style={{
                  padding: '14px 16px',
                  borderRadius: '12px',
                  background: 'rgba(255,165,0,0.04)',
                  border: '1px solid rgba(255,165,0,0.1)',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  transition: 'all 0.25s ease',
                  cursor: 'pointer',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'rgba(255,165,0,0.09)';
                  e.currentTarget.style.borderColor = 'rgba(255,165,0,0.35)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'rgba(255,165,0,0.04)';
                  e.currentTarget.style.borderColor = 'rgba(255,165,0,0.1)';
                }}
              >
                <div
                  style={{
                    width: '44px',
                    height: '44px',
                    borderRadius: '10px',
                    overflow: 'hidden',
                    border: '1px solid rgba(255,165,0,0.3)',
                    flexShrink: 0,
                    backgroundColor: '#0F172A',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.4)',
                  }}
                >
                  <img
                    src={dish.image}
                    alt={dish.name}
                    loading="lazy"
                    onError={(e) => {
                      e.currentTarget.style.display = 'none';
                    }}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      display: 'block',
                    }}
                  />
                </div>
                <span style={{ color: '#CBD5E1', fontSize: '0.86rem', fontWeight: 600, lineHeight: 1.3 }}>
                  {dish.name}
                </span>
              </div>
            ))}
          </div>

          {/* Review Quote — Inline compact horizontal layout */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '16px',
              padding: '16px 24px',
              borderRadius: '14px',
              background: 'rgba(255,107,53,0.05)',
              border: '1px solid rgba(255,165,0,0.15)',
              maxWidth: '640px',
              margin: '0 auto',
            }}
          >
            <div style={{ flexShrink: 0 }}>
              <div style={{ display: 'flex', gap: '2px', marginBottom: '4px' }}>
                {[1,2,3,4,5].map(s => (
                  <span key={s} style={{ color: '#FFA500', fontSize: '0.85rem' }}>★</span>
                ))}
              </div>
              <span style={{ color: '#FFA500', fontSize: '0.7rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em' }}>
                Verified Bidder
              </span>
            </div>
            <div style={{ width: '1px', height: '40px', background: 'rgba(255,165,0,0.2)', flexShrink: 0 }} />
            <p style={{ color: '#E2E8F0', fontSize: '0.92rem', fontWeight: 600, lineHeight: 1.45, fontStyle: 'italic', margin: 0 }}>
              "Absolutely loved it. Amazing food and charismatic chefs."
            </p>
          </div>
        </div>
      </div>

      {/* ── BRAND STORY SECTION ── */}
      <div style={{ padding: '64px 0', background: '#04050E' }}>
        <div className="ht-container">
          <div
            className="hungrytop-about-grid"
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(2, 1fr)',
              gap: '40px',
              alignItems: 'center',
            }}
          >
            {/* Left: Team video */}
            <div
              style={{
                borderRadius: '28px',
                overflow: 'hidden',
                border: '1px solid rgba(255,165,0,0.2)',
                boxShadow: '0 30px 80px rgba(0,0,0,0.7)',
              }}
            >
              <video autoPlay muted loop playsInline style={{ width: '100%', display: 'block' }}>
                <source src="/assets/video/food1-team.mp4" type="video/mp4" />
                <source src="/assets/video/food1-team.webm" type="video/webm" />
              </video>
            </div>

            {/* Right: Brand Story */}
            <div>
              <div
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  background: 'rgba(255,165,0,0.08)',
                  border: '1px solid rgba(255,165,0,0.25)',
                  padding: '6px 16px',
                  borderRadius: '9999px',
                  marginBottom: '24px',
                }}
              >
                <span
                  style={{
                    color: '#FFA500',
                    fontSize: '0.8rem',
                    fontWeight: 800,
                    letterSpacing: '0.15em',
                    textTransform: 'uppercase',
                  }}
                >
                  🍽️ Benvenuto, to our Food Auction Platform
                </span>
              </div>

              <h2
                style={{
                  fontSize: 'clamp(2rem, 3vw, 2.6rem)',
                  fontWeight: 900,
                  color: '#FFFFFF',
                  marginBottom: '28px',
                  lineHeight: 1.2,
                  letterSpacing: '-0.02em',
                }}
              >
                The Platform That
                <span
                  style={{
                    background: 'linear-gradient(135deg, #FF6B35, #FFA500)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',
                  }}
                > Puts You In Control</span>
              </h2>

              <p style={{ color: '#CBD5E1', fontSize: '1.02rem', lineHeight: 1.75, marginBottom: '20px' }}>
                Everything we do, we believe in challenging the set food and beverage industry norms and status quo, reforming and reshaping market dynamics.
              </p>
              <p style={{ color: '#94A3B8', fontSize: '0.98rem', lineHeight: 1.7, marginBottom: '20px' }}>
                The way we challenge the status quo is by making our product uniquely designed, simple to use, and user friendly. We just happen to make your food craving a reality at your price through Auction.
              </p>
              <p style={{ color: '#94A3B8', fontSize: '0.98rem', lineHeight: 1.7, marginBottom: '40px' }}>
                HungryTop is a well-diversified Food &amp; Beverage Auction Platform that offers a paramount range of food products from eminent chefs across the Globe.
              </p>

              <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', alignItems: 'center' }}>
                <a
                  href="https://play.google.com/store/apps/details?id=com.hungrytop"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    padding: '14px 28px',
                    borderRadius: '9999px',
                    background: 'linear-gradient(135deg, #FF6B35 0%, #FFA500 100%)',
                    color: '#FFFFFF',
                    fontWeight: 800,
                    fontSize: '0.95rem',
                    textDecoration: 'none',
                    boxShadow: '0 6px 24px rgba(255,107,53,0.5)',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '8px',
                  }}
                >
                  <i className="fab fa-google-play"></i>
                  Download on Play Store
                </a>
                <Link
                  to="/"
                  style={{
                    padding: '14px 28px',
                    borderRadius: '9999px',
                    background: 'rgba(255,255,255,0.05)',
                    border: '1px solid rgba(255,255,255,0.15)',
                    color: '#FFFFFF',
                    fontWeight: 700,
                    fontSize: '0.95rem',
                    textDecoration: 'none',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '8px',
                  }}
                >
                  <i className="fas fa-arrow-left" style={{ fontSize: '0.85rem' }}></i>
                  Back to HungryTop Tech
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── Shared Site Footer ── */}
      <Footer />

      {/* ── Shared Consultation Modal ── */}
      <ConsultationModal
        isOpen={isConsultationOpen}
        onClose={() => setIsConsultationOpen(false)}
        initialProduct="HungryTop"
      />

      <style>{`
        @keyframes scrollBounce {
          0%, 100% { transform: translateY(0); opacity: 1; }
          50% { transform: translateY(12px); opacity: 0.4; }
        }
        @media (max-width: 768px) {
          .hungrytop-stats-grid {
            grid-template-columns: repeat(2, 1fr) !important;
          }
          .hungrytop-about-grid {
            grid-template-columns: 1fr !important;
            gap: 36px !important;
          }
          .spring-menu-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </div>
  );
};

export default HungryTopProductPage;


